const filter = {
    dateFormat:function(dateStr,time) {

        var date = new Date(dateStr*1000);
        var year = date.getFullYear();
        //ES6语法填充：var month = (date.getMonth()+1).toString().padStart(2, '0');
        var month = date.getMonth()+1<10 ? '0'+ (date.getMonth()+1) : date.getMonth()+1;
        var day = date.getDate()<10 ? '0' + date.getDate() : date.getDate();
        var hh = date.getHours()<10 ? '0' + date.getHours() : date.getHours();
        var mm = date.getMinutes()<10 ? '0' + date.getMinutes() : date.getMinutes();
        var ss = date.getSeconds()<10 ? '0' + date.getSeconds() : date.getSeconds();

        //return `${year}-${month}-${day}`;

        if(time&&time.toLowerCase() === 'yyyy-mm-dd'){
            return `${year}-${month}-${day}`;
        }else if(time&&time.toLowerCase() === 'hh:mm:ss'){
            return `${hh}:${mm}:${ss}`;
        }else{
            return `${year}-${month}-${day} ${hh}:${mm}:${ss}`;
        }
    },
    statusFormat:function(status) {
        let str = '';
        switch (status) {
            case 0: str = '已迁出';break;
            case 1: str = '已入驻';break;
        }
        return str;
    },
    statusClass:function(status) {
        let str = '';
        switch (status) {
            case 0: str = 'label label-danger';break;
            case 1: str = 'label-primary';break;
        }
        return str;
    },
    paymentModeFormat:function(payment){
        let str = '';
        switch (payment) {
            case 1: str = '月付'; break;
            case 2: str = '季度付'; break;
            case 3: str = '半年付'; break;
            case 4: str = '年付'; break;
            default: str = '数据有误'; break;
        }
        return str;
    },
    typeFormat:function(payment){
        let str = '';
        switch (payment) {
            case 1: str = '办公区域'; break;
            case 2: str = '会议区域'; break;
            case 3: str = '公共区域'; break;
            case 4: str = '其他区域'; break;
            default: str = '数据有误'; break;
        }
        return str;
    },
    producerFormat:function(productor){
        let str = '';
        switch (Number(productor)) {
            case 1: str = '云丁'; break;
            case 2: str = '夏洛克'; break;
            case 3: str = '梦想家'; break;
            default: str = '数据有误'; break;
        }
        return str;
    },
    dataType:function(startDate,endDate){
        let str = '';
        if (startDate*1000 < new Date().getTime() && endDate*1000 > new Date().getTime()) {
            str = '进行中';
        }
        else if (endDate*1000 < new Date().getTime()) {
            str = '已结束';
        }
        else if (startDate*1000 > new Date().getTime()) {
            str = '未开始';
        }
        return str;
    },
    financeTypeFormat:function(type){
        let str = '';
        switch (type) {
            case 1: str = '消费'; break;
            case 2: str = '充值'; break;
            default: str = '数据有误'; break;
        }
        return str;
    },
    setCategoryList:function(list){
        let firstList = new Array();
        for(var i in list){
            let item = list[i];
            item.value = item.id;
            item.label = item.name;
            item.item
            if(item.pid == 0){
                firstList.push(item);
            }
        }
        //this.newList = firstList;

        //------------第二次整理---------
        let second = new Array(),thatList = firstList,third = new Array();

        for(var i in firstList){
            second = [];thatList[i].children = new Array();
            for(var j in list){
                let item = firstList[i], that = list[j];
                if(item.id == that.pid){
                    second.push(that);
                    third.push(that);
                }
            }
            thatList[i].children = second;
        }
        firstList = thatList;


        //------------------第三次整理------------------
        //return;
        let newThird = new Array(),my = new Array();

        for (var i in third){
            newThird = [];
            for(var j in list){
                let item = third[i],that = list[j];
                if(item.id == that.pid){
                    newThird.push(that);
                }
            }
            for (var k in firstList) {
                let items = firstList[k].children;
                for (var l in items) {
                    let item = items[l];
                    for(var n in newThird){
                        let myTh = newThird[n];
                        if (myTh.pid == item.id) {
                            item.children = newThird;
                        }
                    }
                }
            }
        }
        return firstList;
    },
}

export default filter;
